export const fillterConstanForBedrooms = ['1', '2', '3', '4', '5+']
export const fillterConstanForBathrooms = ['1', '2', '3', '4', '5+']